import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-a01-message-list-panel" }
const _hoisted_2 = { class: "p-a01-message-list-panel__main" }
const _hoisted_3 = { class: "p-a01-message-list-panel__meta" }
const _hoisted_4 = { class: "p-a01-message-list-panel__users" }
const _hoisted_5 = {
  class: "p-a01-message-list-panel__name",
  "data-translate-skip": ""
}
const _hoisted_6 = {
  class: "p-a01-message-list-panel__name",
  "data-translate-skip": ""
}
const _hoisted_7 = {
  class: "p-a01-message-list-panel__point",
  "data-translate-skip": ""
}
const _hoisted_8 = { class: "p-a01-message-list-panel__point-value" }
const _hoisted_9 = { class: "p-a01-message-list-panel__point-unit" }
const _hoisted_10 = { class: "p-a01-message-list-panel__content" }
const _hoisted_11 = { class: "p-a01-message-list-panel__bubble-wrap" }
const _hoisted_12 = { class: "p-a01-message-list-panel__bubble" }
const _hoisted_13 = {
  class: "p-a01-message-list-panel__message",
  "data-translate-skip": ""
}
const _hoisted_14 = { class: "p-a01-message-list-panel__created_at" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconArrowRight = _resolveComponent("IconArrowRight")!
  const _component_IconBase = _resolveComponent("IconBase")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.message.fromUserName), 1),
          _createVNode(_component_IconBase, {
            class: "p-a01-message-list-panel__arrow",
            width: 24,
            height: 24,
            "view-box": "0 0 24 24",
            "icon-color": "#0d76bf"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IconArrowRight)
            ]),
            _: 1
          }),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.message.toUserName), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.addComma(_ctx.message.points)), 1),
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.unit), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.message.message), 1)
          ])
        ]),
        _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.date), 1)
      ])
    ])
  ]))
}